import { CardBody } from "reactstrap";
import { P } from "../../../../AbstractElements";
import { formatDate } from "../../../../utils/date";

const StudentActivitiesCardBody = ({ studentActivities }) => {
  return (
    <CardBody>
    <div className="activity-timeline todo-timeline mb-2">
      {studentActivities?.map((item, i) => (
        <div className="d-flex" key={i}>
          <div className="activity-line"></div>
          <div className={`activity-dot-primary`}></div>
          <div className="flex-grow-1">
            <P attrPara={{ className: "mt-0 todo-font" }}>
              <span className="font-primary">{formatDate(item?.createdAt)} </span>
              {/* {item.day} */}
            </P>
            <div className="d-flex mt-0">
              <div>
                <span className="f-w-600"><strong>Type:</strong> {item.type} </span>  
                <i className={`fa fa-circle circle-dot-primary pull-right`}></i>
                <P attrPara={{ className: "mb-0" }}>{item.activity}</P>
                <div className="d-block">
                  <a className="link-hover-effect text-secondary" href={`/studentactivity?isOpenDetails=true&id=${item?.id}`} target="_blank">View Details</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </CardBody>
  );
};

export default StudentActivitiesCardBody;